var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSecureEssentials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.974 2.903 8.526.474 7.5.02v8.894L9.542 6.87a1.005 1.005 0 0 1 1.413 0 1.005 1.005 0 0 1 0 1.413L7.5 11.739v4.722c-.01.271-.02 1.742-.029 2.816v.03c.01-.01.02-.01.029-.01.01 0 .02-.01.029-.01 4.432-1.858 6.59-4.635 7.045-7.935.348-2.497.416-5.313.426-6.842a1.732 1.732 0 0 0-1.026-1.607z",
    fill: "#F3ADAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.451V11.73l-.571.57L4.5 9.872a1.005 1.005 0 0 1 0-1.413 1.005 1.005 0 0 1 1.413 0l1.016 1.016.57-.57V0L6.475.455 1.026 2.884A1.73 1.73 0 0 0 0 4.47C.01 6 .087 8.816.426 11.313c.455 3.3 2.613 6.077 7.045 7.935.01 0 .02.01.029.01.01 0 .02.01.029.01v-.03c-.01-1.045-.02-2.516-.03-2.787z",
    fill: "#DF2226"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureEssentials);
export default __webpack_public_path__ + "static/media/secure-essentials.e65c577083fa85fc2e3dc8a4a6bd1053.svg";
export { ForwardRef as ReactComponent };